import List from "./List.js";
import Show from "./Show.js";
import Edit from "./Edit.js";
import Create from "./Create.js";

export default { List, Show, Edit, Create };
